import React, { useState, useEffect } from "react";
import { fetchChatbots } from "../../services/api/ManagerService";
import NoRecordFound from "../../components/NoRecordFound/NoRecordFound";
import KnowledgeBaseCards from "../../components/KnowledgeBase/KnowledgeBaseCards";
import Omnisearch from "../../components/Omnisearch/Omnisearch";
import { useRecoilValue } from "recoil";
import { currentUserState } from "../../states/atoms";
import PageLayout from "../PageLayout";
import { useNavigate } from "react-router-dom";

function ViewKnowledgeBase() {
  const [datastores, setDatastores] = useState([]);
  const [filteredDatastore, setFilteredDatastore] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOption, setSortOption] = useState("alphabetical");
  const user = useRecoilValue(currentUserState);
  let navigate = useNavigate();

  useEffect(() => {
    const getDatastores = async () => {
      const data = await fetchChatbots().catch((e) => console.log(e));
      setDatastores(data);
    };
    if (user) {
      getDatastores();
    }
  }, [user]);

  const applyFilterAndSort = (term, option, sourceList) => {
    let list = [...sourceList];
    if (term) {
      list = list.filter(
        (item) =>
          item.chatbot_name.toLowerCase().includes(term.toLowerCase()) ||
          item.chatbot_description.toLowerCase().includes(term.toLowerCase())
      );
    }

    if (option === "alphabetical") {
      list.sort((a, b) => a.chatbot_name.localeCompare(b.chatbot_name));
    } else if (option === "date") {
      list.sort((a, b) => new Date(b.time_created) - new Date(a.time_created));
    }

    return list;
  };

  useEffect(() => {
    const newList = applyFilterAndSort(searchTerm, sortOption, datastores);
    setFilteredDatastore(newList);
  }, [datastores, searchTerm, sortOption]);

  const handleSearch = (term) => {
    setSearchTerm(term);
  };

  if (!user.is_admin && !user.is_builder) {
    return navigate("/chat");
  }

  return (
    <PageLayout>
      <div className="pr-4 pl-2 lg:pl-0 pb-2 overflow-auto">
        <div className="md:mt-10 pr-2 pl-8">
          <h1 className="text-2xl font-bold">Chatbots</h1>
        </div>

        <div className="mt-2 w-full lg:w-1/2 lg:mt-5 pl-8">
          <Omnisearch onSearch={handleSearch} />
        </div>

        <div className="flex justify-end mt-4 pr-8">
          <select
            value={sortOption}
            onChange={(e) => setSortOption(e.target.value)}
            className="text-sm border border-gray-300 rounded-xl px-3 py-1 shadow-sm focus:outline-none focus:ring-2 focus:ring-[#52aeb4]"
          >
            <option value="alphabetical">Sort: A-Z</option>
            <option value="date">Sort: Latest</option>
          </select>
        </div>

        <div className="mt-5 lg:mt-10">
          {filteredDatastore.length > 0 ? (
            <KnowledgeBaseCards
              datastores={filteredDatastore}
              onDelete={(updatedFiltered) => {
                setDatastores(updatedFiltered);
                setFilteredDatastore(
                  applyFilterAndSort(searchTerm, sortOption, updatedFiltered)
                );
              }}
            />
          ) : (
            <NoRecordFound />
          )}
        </div>
      </div>
    </PageLayout>
  );
}

export default ViewKnowledgeBase;
